import React from 'react';
import {NavLink  } from 'react-router-dom'

const About = (props)=>{
 
  return(
  <div className='mypage fluid-container p-3'> 
  <h2>About</h2>
  <p>This site is dedicated to my parents and my family. It's always been my dream to have a site to publish games. I hope to someday invite other like minded developers to participate.  I think it's high time to bring some of the creativity, flavor, ideas and camaraderie, I experienced in the 80's in Arcades with my friends.  Back then it was a quarter to play 1 game. Please enjoy the content and if you can support the development efforts so there's MOAR!</p>
  <p>The site is currently in pre-alpha or friends and family. Please be understanding, as I am trying to build the site and offer as much entertainment for free as I can, while I can. Thanks for understanding and enjoy!</p>
  <NavLink to="/policy"> <h4>Site Policies Link</h4> </NavLink>
  </div>  
  
  

    
    
  )};
  
export default About;  


// WEBPACK FOOTER //
// ./src/container/Pages/About.js